import { useCallback, useContext, useEffect, useState } from "react";
import Select, { components } from "react-select";
import { debounce } from "lodash";
import { confirmAlert } from "react-confirm-alert";
import ClipLoader from "react-spinners/ClipLoader";
import AsyncSelect from "react-select/async";
import { BaseURL } from "../../../../Reusable/BaseURL";
import { UserContext } from "../../../../Context/UserContext";
import { CustomConfirmDialog } from "../../../../Reusable/CustomConfirmDialog";

export const DirectPOCreateDivisionSelect = ({
  changingSelect,
  setChangingSelect,
  selectedOption,
  setSelectedOption,
  setEmpty,
  // addMoreToggle,
  unsavedIndentItem,
  setUnsavedIndentItem,
  myCacheDivision,
  getUnsavedItemList,
  // disabled,
  updDivision,
  setBrand,
  setItem,
  setUnit,
  setQty,
  setInitialLoading,
}) => {
  const { darkTheme, loginData, setIndentAddItemLoading, indentUpdateData } =
    useContext(UserContext);

  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchCacheDivision();
  }, [myCacheDivision]);

  // async function initialIndentDivisionData() {
  //   const response = await fetch(`${BaseURL}/purchase/indent/divisions`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   });
  //   const data = await response.json();
  //   // if(data.status){
  //   //   setIndentAddItemLoading(false)
  //   // }
  //   const transformedOptions = data.data.data.map((item) => ({
  //     value: item.division,
  //     label: item.division,
  //   }));
  //   setOptions(transformedOptions);
  // }

  async function fetchInitialData() {
    if (selectedOption !== "") {
      setIsLoading(true);
      const response = await fetch(
        `${BaseURL}/purchase/indent/divisions?q=${selectedOption}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${loginData.token}`,
          },
        }
      );
      const data = await response.json();
      const myFilter = data.data.data.filter(
        (item) => item.division === selectedOption
      );
      const transformedOptions = myFilter.map((item) => ({
        value: item.division,
        label: item.division,
      }));
      const myFind = transformedOptions.find(
        (item) => item.label === selectedOption
      );
      if (myFind) {
        setSelectedOption(myFind);
      }
      console.log({ myFind });
      if (data.status === true || data.status === false) {
        setIsLoading(false);
      }
    }
    // initialIndentDivisionData();
  }
  async function fetchInitialUpdDivision() {
    if (selectedOption !== "") {
      setIsLoading(true);
      const response = await fetch(
        `${BaseURL}/purchase/indent/divisions?q=${selectedOption}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${loginData.token}`,
          },
        }
      );
      const data = await response.json();
      const myFilter = data.data.data.filter(
        (item) => item.division === selectedOption
      );
      const transformedOptions = myFilter.map((item) => ({
        value: item.division,
        label: item.division,
      }));
      const myFind = transformedOptions.find(
        (item) => item.label === selectedOption
      );
      if (myFind) {
        setSelectedOption(myFind);
      }
      console.log({ updDivision: myFind });
      if (data.status === true || data.status === false) {
        setIsLoading(false);
      }
    }
    // initialIndentDivisionData();
  }

  // cache division
  async function fetchCacheDivision() {
    try {
      if (myCacheDivision !== "") {
        // setInitialLoading(true);
        setIsLoading(true);
        const response = await fetch(
          `${BaseURL}/purchase/indent/divisions?q=${myCacheDivision}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${loginData.token}`,
            },
          }
        );
        const data = await response.json();
        const myFilter = data.data.data.filter(
          (item) => item.division === myCacheDivision
        );
        const transformedOptions = myFilter.map((item) => ({
          value: item.division,
          label: item.division,
        }));
        const myFind = transformedOptions.find(
          (item) => item.label === myCacheDivision
        );
        if (myFind) {
          setSelectedOption(myFind);
        }
        if (data.status === true || data.status === false) {
          setIsLoading(false);
          // setInitialLoading(false);
        } else {
          setIsLoading(false);
          // setInitialLoading(false);
        }
      }
      // initialIndentDivisionData();
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  }

  // Function to fetch data based on input
  // const fetchData = useCallback(
  //   debounce(async (input) => {
  //     setIsLoading(true);
  //     const response = await fetch(
  //       `${BaseURL}/purchase/indent/divisions?q=${input}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           Accept: "application/json",
  //           Authorization: `Bearer ${loginData.token}`,
  //         },
  //       }
  //     );
  //     const data = await response.json();
  //     const transformedOptions = data.data.data.map((item) => ({
  //       value: item.division,
  //       label: item.division,
  //     }));
  //     setOptions(transformedOptions);
  //     if (data.status === true || data.status === false) {
  //       setIsLoading(false);
  //     }
  //     setEmpty("");
  //   }, 300),
  //   []
  // );

  // Function to load options based on user input
  const loadOptions = (inputValue, callback) => {
    fetch(`${BaseURL}/purchase/indent/divisions?q=${inputValue}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const options = data.data.data.map((item) => ({
          label: item.division,
          value: item.division,
        }));
        callback(options);
        // setEmpty("")
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        callback([]);
        // setEmpty("")
      });
  };
  const debouncedLoadOptions = debounce(loadOptions, 400);
  useEffect(() => {
    if (!selectedOption) {
      setEmpty(""); // update problem item not set-solved.
    }
  }, [selectedOption]);

  // Fetch initial data on component mount
  useEffect(() => {
    fetchInitialData();
    // setIndentAddItemLoading(false);
  }, [changingSelect]);

  useEffect(() => {
    fetchInitialUpdDivision();
  }, [indentUpdateData.division]);

  // SET CACHE for division
  async function postCacheItem(divisionLabel) {
    const selectedData = {
      division: divisionLabel,
    };
    const response = await fetch(`${BaseURL}/purchase/po/setcache`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(selectedData),
    });
    const data = await response.json();
    // console.log("divisiiiiData", data);
    // console.log("selectDivsion", selectedData);
  }

  // CHANGE DIVISION CONFIRMATION
  // function checkDivsionChange(myChoice) {
  //   // if(unsavedIndentItem.length > 0){
  //   divisionChange(myChoice);
  //   // }
  // }
  // function divisionChange(myChoice) {
  //   const options = {
  //     title: "Are you sure: Change-Division?",
  //     message: "Your Added items will be Removed.",
  //     buttons: [
  //       {
  //         label: "Yes",
  //         onClick: () => changeConfirm(),
  //       },
  //       {
  //         label: "No",
  //         // onClick: () => alert('Click No')
  //       },
  //     ],
  //     closeOnEscape: true,
  //     closeOnClickOutside: true,
  //     keyCodeForClose: [8, 32],
  //     willUnmount: () => {},
  //     afterClose: () => {},
  //     onClickOutside: () => {},
  //     onKeypress: () => {},
  //     onKeypressEscape: () => {},
  //     overlayClassName: "overlay-custom-class-name",
  //   };
  //   function changeConfirm() {
  //     // setUnsavedIndentItem([]);
  //     setSelectedOption(myChoice);
  //     if (selectedOption.label !== "") {
  //       postCacheItem();
  //     }
  //   }
  //   confirmAlert(options);
  // }

  // CHANGE DIVISION CONFIRMATION
  function checkDivsionChange(myChoice) {
    // if(unsavedIndentItem.length > 0){
    showDialog(myChoice);
    // }
  }
  const showDialog = (myChoice) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <CustomConfirmDialog
            title="Are you sure?:Change-Division!"
            message="Your Added items will be Removed."
            onConfirm={() => {
              const changeConfirm = async () => {
                // setUnsavedIndentItem([]);
                setSelectedOption(myChoice);
                // console.log("mychoice-warning", myChoice);
                if (myChoice.label) {
                  await postCacheItem(myChoice.label);
                  await getUnsavedItemList();
                  // console.log("insidddd-change", myChoice);
                }
                setBrand("");
                setItem("");
                setUnit("");
                setQty("");
              };
              changeConfirm();
              onClose();
            }}
            onCancel={onClose}
          />
        );
      },
    });
  };
  // close check division change

  // Handle option select
  const handleChange = (selectedOption) => {
    // if (indentUpdateData?.division) {
    //   setSelectedOption(selectedOption);
    //   // postCacheItem(updDivision)
    //   console.log("updDivision-length-item", selectedOption);
    // }
    if (unsavedIndentItem.length > 0) {
      checkDivsionChange(selectedOption);
      // console.log("handlediv-1", option);
    } else {
      setSelectedOption(selectedOption);
      if (selectedOption?.label) {
        postCacheItem(selectedOption.label);
        // console.log("handlediv-2", option);
      }
      // if(updDivision){
      //   setSelectedOption(updDivision)
      //   postCacheItem(updDivision)
      //   console.log("updDivision-else",updDivision)
      // }
    }
  };

  // Custom styling
  const customStyles = {
    // loading style
    // menuList: (provided) => ({
    //   ...provided,
    //   display: "flex",
    //   justifyContent: "center",
    //   alignItems: "center",
    //   minHeight: "50px",
    //   flexDirection: "column",
    //   textTransform: "uppercase",
    // }),

    container: (provided) => ({
      ...provided,
      width: "100%",
      margin: "0 auto",
      color: `${darkTheme ? "white" : "black"}`,
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      borderColor: "none",
      boxShadow: "none",
      "&:hover": {
        borderColor: "none",
      },
      borderRadius: "8px",
      border: "none",
      padding: "0 2px",
      color: `${darkTheme ? "#fffa" : "#111a"}`,
      textTransform: "uppercase",
      border: `${darkTheme ? "1px solid #6B7280" : "1px solid #6B7280"}`,
    }),
    // if you use menuList style comment this menu style
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      backgroundColor: `${darkTheme ? "#374151" : "#ffff"}`,
      textTransform: "uppercase",
      border: "1px solid #6B7280",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#2a60a0"
        : state.isFocused
        ? "#0ffa"
        : darkTheme
        ? "#374151"
        : "#ffff",
      color: state.isSelected ? "white" : "black",
      "&:active": {
        backgroundColor: "#aad",
        color: "white",
      },
      padding: "4px 10px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: `${darkTheme ? "white" : "black"}`,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: `${darkTheme ? "white" : "black"}`,
      fontWeight: "400",
      fontSize: "14px",
      textTransform: "uppercase",
    }),
  };

  const MenuList = (props) => {
    const { isLoading, children } = props;
    return (
      <components.MenuList {...props}>
        {isLoading ? (
          <div
            style={
              {
                // display: "flex",
                // flexDirection: "row",
                // justifyContent: "center",
                // alignItems: "center",
                // height: "100%",
              }
            }
          >
            <ClipLoader color="#000" loading={isLoading} size={30} />
          </div>
        ) : (
          children
        )}
      </components.MenuList>
    );
  };

  return (
    <AsyncSelect
      styles={customStyles}
      cacheOptions
      loadOptions={debouncedLoadOptions}
      defaultOptions
      onChange={handleChange}
      value={selectedOption}
      // defaultValue={defValue}
      placeholder="Select"
      isLoading={isLoading}
      // components={{
      //   MenuList: (props) => <MenuList {...props} isLoading={isLoading} />,
      // }}
      closeMenuOnSelect={true}
      className="react-select-container"
      classNamePrefix="react-select"
      isClearable
      // isDisabled={disabled ? disabled : false}
    />
  );
};
